import { YoYEmission } from 'models/MainDashboard/yoyModel.model';
import { serializable, object, list, primitive, alias } from 'serializr';

class SbtiTarget {
  @serializable(primitive())
  id?: number;

  @serializable(alias('is_sme', primitive()))
  isSME?: boolean;

  @serializable(alias('organization_id', primitive()))
  organizationId?: number;

  @serializable(alias('organization_name', primitive()))
  organizationName?: string;

  @serializable(alias('baseline_year', primitive()))
  baselineYear?: number;

  @serializable(alias('target_year', primitive()))
  targetYear?: number;

  @serializable(alias('target_name', primitive()))
  targetName?: string;

  @serializable(alias('target_category', primitive()))
  targetCategory?: string;

  @serializable(alias('target_type', primitive()))
  targetType?: string;

  @serializable(alias('target_coverage', primitive()))
  targetCoverage?: string;

  @serializable(alias('target_setting_method', primitive()))
  targetSettingMethod?: string;

  @serializable(primitive())
  notes?: string;

  @serializable(alias('total_reduction', primitive()))
  totalReduction?: number;

  @serializable(primitive())
  scope1?: number;

  @serializable(primitive())
  scope2?: number;

  @serializable(alias('scope1_scope2', primitive()))
  scope1Scope2?: number;

  @serializable(alias('base_year_emission', primitive()))
  baseYearEmission?: number;

  @serializable(alias('target_year_emissions', primitive()))
  totalYearEmissions?: number;

  @serializable(alias('annual_reduction', primitive()))
  annualReduction?: number;

  @serializable(alias('yoy_emission', list(object(YoYEmission))))
  yoyEmission?: YoYEmission[];
}

class SbtiResponse {
  @serializable(alias('sbti_targets', list(object(SbtiTarget))))
  sbtiTarget?: SbtiTarget[];

  @serializable(primitive())
  message?: string;
}

export { YoYEmission, SbtiTarget, SbtiResponse };
